module.exports = __webpack_public_path__ + "static/img/szbl_1.f4e439e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szbl_1.svg
// module id = EecQ
// module chunks = 1